import React from 'react';
import {FormattedMessage} from 'react-intl';
import {realmConfig} from '../../config/realmConfig';

const VerticalSeparator = () => <span className="separator" />;

const privacyPolicyUrl = realmConfig.get('cocosite.privacypolicy.url');
const tosUrl = realmConfig.get('cocosite.tos.url');

export const FooterBX2025 = () => {
  return (
    <footer className="footer-2025 d-flex flex-wrap align-items-center justify-content-center px-5 text-center ">
      {tosUrl && (
        <>
          <a href={tosUrl} className="text-decoration-none" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="loginsite.footer.terms" />
          </a>
          <VerticalSeparator />
        </>
      )}
      {privacyPolicyUrl && (
        <>
          <a href={privacyPolicyUrl} className="text-decoration-none" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="loginsite.footer.privacy" />
          </a>
          <VerticalSeparator />
        </>
      )}

      <a className="text-decoration-none" href="https://learnifier.com" target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="loginsite.footer.powered.whitelabel" />
      </a>
    </footer>
  );
};
